import React, { Fragment, useState } from 'react';

import useCategories from '../../hooks/useCategories';

import MoveDraftModal from '../move/MoveDraftModal';
import CategoryFolderTitle, { CategoryIcon, FolderIcon } from '../page/CategoryFolderTitle';
import { canSuggestEdit } from '../../utilities/permissionsUtilities';

const CATEGORY_ICON = '/img/icons/category-icon.svg';
const DEFAULT_COLOR = 'd8d8d8';
const FOLDER_ICON = '/img/icons/folder-icon.svg';

const getCategoryId = (folderId, categories) => {
    const categoryId = window._tettraDraft ? window._tettraDraft.category_id : window.draftCategoryId;
    if (!folderId || categoryId) return categoryId;

    const category = Object.values(categories).find((category) => category.folders[folderId]);

    if (!category) return null;

    window._tettraDraft.category_id = category.id;

    return category.id;
};

const DraftCategoryFolderSelector = (props) => {
    const [showModal, setShowModal] = useState(false);
    const categories = useCategories();

    if (!categories) return null;

    const defaultText = 'Choose Category / Subcategory';
    let category; let categoryName; let folder; let
        folderName;
    let categoryIcon = CATEGORY_ICON;
    let categoryColor = DEFAULT_COLOR;
    let folderIcon = FOLDER_ICON;
    let folderColor = DEFAULT_COLOR;
    let isNested = false;

    const folderId = window._tettraDraft ? window._tettraDraft.folder_id : window.draftFolderId;
    const categoryId = getCategoryId(folderId, categories);

    if (categoryId && !isNaN(categoryId)) {
        category = window.categoriesAndFoldersMap[categoryId];
        categoryName = category.name;
        categoryColor = category.color;
        categoryIcon = category.icon;
    } else if (categoryId) {
        categoryName = categoryId;
    }

    if (folderId && !isNaN(folderId)) {
        folder = category.folders[folderId];
        folderName = folder.name;
        folderIcon = folder.icon;
        folderColor = folder.color;
        isNested = !!folder.parent_folder_id;
    } else if (folderId) {
        folderName = folderId;
    }

    const handleClickCategoryLocaltion = () => {
        if (!canSuggestEdit()) {
            setShowModal(true);
        }
    };

    if (canSuggestEdit() && !categoryName) return null;
    return (
        <Fragment>
            <button className="btn rounded flex flex-auto flex-shrink" onMouseDown={() => handleClickCategoryLocaltion()} aria-label="move draft" type="button">
                <CategoryFolderTitle
                    categoryName={categoryName}
                    categoryIcon={categoryIcon}
                    categoryColor={categoryColor}
                    folderName={folderName}
                    folderIcon={folderIcon}
                    folderColor={folderColor}
                    isNested={isNested}
                    defaultText={defaultText}
                />
            </button>
            {showModal && <MoveDraftModal closeModal={() => setShowModal(false)} />}
        </Fragment>
    );
};

export default DraftCategoryFolderSelector;
